import React, {Component} from 'react'
import {observer} from 'mobx-react'
import InputBinder from './InputBinder'
import ShowTextBinder from './ShowTextBinder'
class Text extends Component {
  render() {
    return (<div>
      <ShowTextBinder></ShowTextBinder>
      <InputBinder></InputBinder>
    </div>)
  }
}

export default Text



// WEBPACK FOOTER //
// ./src/textModule/Text.js